import { Menu } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
min-width: 18rem;
color: white;
margin-top: 17px !important;
background: none !important;
overflow-y: auto; 
::-webkit-scrollbar {
  width: 6px;
  background-color: #3399FF;
  border-radius: 3px;
  top: 15px;
  color: #1A3175;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3) !important;
  background-color: #D6D6D6 !important;
}
 .itemWrapper {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: white;
 }

 .dropdownDivider {  
 }

 .titleWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
}
 > div {
   cursor: pointer;
 }
 > a.item {
   &:hover {
      background-color: #304993 !important;
      color: #ffffff !important;
    }
   color: white !important;
    &.active {
      background-color: #304993 !important;
      color: white !important;
    }
 }
 .menu {
   margin: auto !important;
   margin-top: 10px !important;
   .item {
    padding-left: 0.9em !important;
   }
    a.item {    
    &:hover {
      background-color: #304993 !important;
      color: #ffffff !important;
    }
    padding: 0.92857143em 0.9em !important;
    color: white !important;
    &.active {      
      background-color: #304993 !important;
      color: white !important;
    }
   }
 } 
`
